import { environment } from '../../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private httpClient: HttpClient) {}

  getUsersLength(): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/users/length');
  }
  getUsers(currentPage: number, pageSize: number): Observable<any> {
    const queryParams = '?currentpage=' + currentPage + '&pagesize=' + pageSize;
    return this.httpClient.get(environment.apiURL + '/users' + queryParams);
  }
  getUserRoles(): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/users/roles');
  }

  updateUser(
    firstname: string,
    surname: string,
    email: string,
    roleID: string,
    userID: string
  ): Observable<any> {
    const userData = {
      firstname,
      surname,
      email,
      role_id: roleID,
      user_id: userID,
    };

    console.log('userData a modificar: ', userData);
    return this.httpClient.post(environment.apiURL + '/user', userData);
  }

  getUser(userID: string): Observable<any> {
    return this.httpClient.get(environment.apiURL + '/user/' + userID);
  }

  deleteUser(userID: string): Observable<any> {
    return this.httpClient.delete(environment.apiURL + '/user/' + userID);
  }
}
